import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import MenuContent from './menu-content'
import { getCurrentLanguage } from 'utils/language'
import _ from 'lodash'

const Header = ({ isSticky, mode }) => {
  return (
    <StaticQuery
      query={graphql`
        {
          vi: markdownRemark(fields: { slug: { eq: "/vi/site-config/" } }) {
            frontmatter {
              header {
                menu {
                  name
                  link
                }
              }
            }
          }
          en: markdownRemark(fields: { slug: { eq: "/en/site-config/" } }) {
            frontmatter {
              header {
                menu {
                  name
                  link
                }
              }
            }
          }
        }
      `}
      render={data => {
        const currentLanguage = getCurrentLanguage()
        let menu = []
        if (_.has(data, currentLanguage)) {
          menu = data[currentLanguage].frontmatter.header.menu
        }
        return <MenuContent mode={mode} menu={menu} sticky={isSticky} />
      }}
    />
  )
}

Header.propTypes = {
  mode: PropTypes.oneOf(['dark', 'light']),
  bg: PropTypes.bool
}

Header.defaultProps = {
  mode: 'light',
  bg: true
}

export default Header
